import React from 'react';
import { Box } from '@mui/material';
import SurfaceCard from './SurfaceCard';

interface FilterBarProps {
  children: React.ReactNode;
}

const FilterBar: React.FC<FilterBarProps> = ({ children }) => {
  return (
    <SurfaceCard
      sx={{
        p: 2,
        mb: 3,
        borderRadius: 3,
        background: 'linear-gradient(180deg, rgba(18, 30, 48, 0.86) 0%, rgba(14, 22, 36, 0.92) 100%)',
      }}
    >
      <Box sx={{ display: 'flex', gap: 1.6, alignItems: 'center', flexWrap: 'wrap' }}>
        {children}
      </Box>
    </SurfaceCard>
  );
};

export default FilterBar;
